import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { IntersectionPaginationOption, IntersectionStateChanger, NavBarSubItem } from '@/utils/types';
import NavSubItem from './NavSubItem.vue';
import LoadingSpinner from '../../loaders/LoadingSpinner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavSubItemList',
  props: {
    subItems: null,
    parentIndex: null,
    minimized: { type: Boolean, default: false },
    hasInfiniteHandler: { type: Boolean, default: false }
  },
  emits: ["subItemClicked", "handleIntersection"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'subItemClicked', index: number, subIndex: number): void;
  (e: 'handleIntersection', index: number, state: IntersectionStateChanger): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { subItems: NavBarSubItem[], parentIndex: number, minimized: boolean, hasInfiniteHandler: boolean };





const paginationRef = ref<IntersectionPaginationOption>({
  loaded: false,
  completed: false,
  searchText: undefined, 
  bounceTimer: undefined
})

const state: IntersectionStateChanger = {
  loaded: () => {
    paginationRef.value.loaded = true;
  },
  completed: () => {
    paginationRef.value.completed = true;
  },
  reset: () => {
    paginationRef.value.loaded = false;
    paginationRef.value.completed = false;
  }
};

function handleIntersection(entries: IntersectionObserverEntry[], observer: IntersectionObserver, isIntersecting: boolean) {
  if(!isIntersecting) {
    paginationRef.value.loaded = false;
    return;
  }
  if(paginationRef.value.completed) return;
  paginationRef.value.loaded = false;
  emit('handleIntersection', props.parentIndex, state);
}

return { __sfc: true,props, emit, paginationRef, state, handleIntersection, NavSubItem, LoadingSpinner }
}

})